import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  get,
  post,
  patch,
  remove,
  put,
  getResponseWithStatus,
} from '../models/base';

export const createFolder = createAsyncThunk(
  'folders/createFolder',
  async (_, { rejectWithValue, getState }) => {
    const { album } = getState().album;
    const { folders } = getState().folders;

    const data = {
      name: `Folder ${folders.length + 1}`,
      album_id: album.id,
    };
    try {
      const response = await post(`/albums/${album.id}/folders`, data);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchFolder = createAsyncThunk(
  'folders/fetchFolder',
  async (folderId, { rejectWithValue, getState }) => {
    const { album } = getState().album;
    const { folders } = getState().folders;
    folderId = folderId || folders[0].id;

    try {
      const response = await get(`/api/albums/${album.id}/folders/${folderId}`);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const updateFolder = createAsyncThunk(
  'folders/updateFolder',
  async (folderId, { rejectWithValue, getState }) => {
    const { album } = getState().album;
    const { folder } = getState().folders;

    try {
      const response = await patch(`/albums/${album.id}/folders/${folderId}`, {
        name: folder.name,
      });
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const deleteFolder = createAsyncThunk(
  'folders/deleteFolder',
  async (folderId, { rejectWithValue, getState }) => {
    const { album } = getState().album;

    try {
      await remove(`/albums/${album.id}/folders/${folderId}`);
      return folderId;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const downloadSelectedPhotos = createAsyncThunk(
  'folders/downloadSelectedPhotos',
  async (folderId, { rejectWithValue, getState }) => {
    const { album } = getState().album;
    try {
      const queryPath = `/albums/${album.id}/zip_album?folder_id=${folderId}`;
      const response = await put(queryPath);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchDownloadStatus = createAsyncThunk(
  'folders/fetchDownloadStatus',
  async (zipRequestId, { rejectWithValue, getState }) => {
    const { album } = getState().album;

    try {
      const queryPath = `/albums/${album.id}/folders/selected_download_status?album_zip_request_id=${zipRequestId}`;
      const response = await get(queryPath);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
